import React, { useState, useRef, useEffect } from 'react';
// Importy do wylogowywania z Firebase
import { auth } from '../firebase';
import { signOut } from 'firebase/auth';
import { useNavigate, NavLink, useLocation } from 'react-router-dom';

import { useAuth } from '../context/AuthContext';
// --- ZMIANA: Importujemy nasz AuthModal ---
import AuthModal from '../components/AuthModal';

function Navbar() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const desktopDropdownRef = useRef(null);
  const mobileDropdownRef = useRef(null);

  const navigate = useNavigate();
  const location = useLocation();
  const isCreatePage = location.pathname === '/create'; // <-- DODAJ TO

  const { currentUser } = useAuth();

  const [searchQuery, setSearchQuery] = useState('');
  const [isMobileSearchOpen, setIsMobileSearchOpen] = useState(false);

  // --- ZMIANA: Stany do zarządzania Modalem ---
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [authModalMode, setAuthModalMode] = useState('login'); // 'login' lub 'signup'

  const [isSubmittingPost, setIsSubmittingPost] = useState(false);

  useEffect(() => {
    const handleSubmitting = (e) => setIsSubmittingPost(e.detail);
    window.addEventListener('post-submitting-state', handleSubmitting);
    return () =>
      window.removeEventListener('post-submitting-state', handleSubmitting);
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const searchParam = params.get('search');
    if (searchParam) {
      setSearchQuery(searchParam);
    } else {
      setSearchQuery('');
    }
  }, [location.search]);

  useEffect(() => {
    function handleClickOutside(event) {
      const isOutsideDesktop =
        desktopDropdownRef.current &&
        !desktopDropdownRef.current.contains(event.target);
      const isOutsideMobile =
        mobileDropdownRef.current &&
        !mobileDropdownRef.current.contains(event.target);

      if (isOutsideDesktop && isOutsideMobile) {
        setIsDropdownOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      setIsDropdownOpen(false);
      navigate('/');
    } catch (error) {
      // console.error('Błąd podczas wylogowywania:', error);
    }
  };

  const handleSearch = (e) => {
    if (e.key === 'Enter') {
      if (searchQuery.trim()) {
        navigate(`/home?search=${encodeURIComponent(searchQuery.trim())}`);
      } else {
        navigate(`/home`);
      }
      setIsMobileSearchOpen(false);
    }
  };

  const handleMenuNavigation = (path) => {
    setIsDropdownOpen(false);
    navigate(path);
  };

  // --- ZMIANA: Funkcja otwierająca Modal i zamykająca Dropdown ---
  const handleOpenAuthModal = (mode) => {
    setIsDropdownOpen(false); // Zamykamy małe menu po kliknięciu
    setAuthModalMode(mode); // Ustawiamy, czy to logowanie czy rejestracja
    setIsAuthModalOpen(true); // Otwieramy duże okienko Modala
  };

  return (
    <>
      <header className="fixed bottom-0 left-0 z-50 h-min w-full bg-white pb-[env(safe-area-inset-bottom)] lg:top-0 lg:pb-0">
        {/* --- DESKTOP NAVBAR --- */}
        <div className="hidden h-16 items-center justify-between px-6 lg:flex">
          <div className="flex flex-1 items-center gap-6">
            <nav className="flex items-center gap-7 font-Outfit text-lg font-medium">
              <NavLink
                to="/home"
                className={({ isActive }) =>
                  `cursor-pointer transition-colors hover:text-gray-500 ${
                    isActive ? 'text-gray-900 underline' : 'text-gray-900'
                  }`
                }
              >
                Explore
              </NavLink>

              <NavLink
                to="/create"
                className={({ isActive }) =>
                  `cursor-pointer transition-colors hover:text-gray-500 ${
                    isActive ? 'text-gray-900 underline' : 'text-gray-900'
                  }`
                }
              >
                Create
              </NavLink>

              <NavLink
                to="/saved"
                className={({ isActive }) =>
                  `cursor-pointer transition-colors hover:text-gray-500 ${
                    isActive ? 'text-gray-900 underline' : 'text-gray-900'
                  }`
                }
              >
                Saved
              </NavLink>
            </nav>
          </div>

          <div className="flex flex-1 justify-center">
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyDown={handleSearch}
              placeholder="Search for ideas"
              className="h-11 w-[40vw] max-w-[580px] rounded-[20px] bg-[#EBEBEB] pl-4 font-Outfit font-semibold text-[#000000] placeholder:text-[#747474] focus:outline-none"
            />
          </div>

          <div className="flex flex-1 items-center justify-end gap-6">
            <div className="relative" ref={desktopDropdownRef}>
              <img
                src={currentUser?.photoURL || '/icons/defaultProfilePic.svg'}
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                width={40}
                height={40}
                className={`h-10 w-10 cursor-pointer transition-opacity hover:opacity-80 ${currentUser ? 'rounded-full' : ''}`}
                alt="profile"
              />

              {isDropdownOpen && (
                <div className="absolute right-0 top-14 z-50 flex w-48 flex-col rounded-[16px] border border-gray-100 bg-white p-2 font-Outfit text-sm shadow-xl">
                  {currentUser ? (
                    <>
                      <button
                        onClick={() => handleMenuNavigation('/profile')}
                        className="cursor-pointer rounded-lg px-4 py-2 text-left font-medium hover:bg-gray-100"
                      >
                        Profile
                      </button>
                      <hr className="my-1 border-gray-200" />
                      <button
                        onClick={handleLogout}
                        className="cursor-pointer rounded-lg px-4 py-2 text-left font-bold text-red-500 hover:bg-red-50"
                      >
                        Sign Out
                      </button>
                    </>
                  ) : (
                    // --- ZMIANA: Widok dla gościa otwiera Modal ---
                    <button
                      onClick={() => handleOpenAuthModal('login')}
                      className="cursor-pointer rounded-lg px-4 py-2 text-left font-bold text-[#620a85] hover:bg-gray-100"
                    >
                      Log in / Sign up
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* --- MOBILE NAVBAR --- */}
        <div className="flex h-16 items-center justify-evenly border-t border-gray-100 lg:hidden">
          {isMobileSearchOpen ? (
            <div className="animate-fadeIn flex w-full items-center gap-3 px-4">
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyDown={handleSearch}
                placeholder="Search..."
                autoFocus
                className="h-10 flex-1 rounded-[20px] bg-[#EBEBEB] pl-4 font-Outfit font-medium text-[#000000] placeholder:text-[#747474] focus:outline-none"
              />
              <button
                onClick={() => setIsMobileSearchOpen(false)}
                className="cursor-pointer font-Outfit font-bold text-gray-600 transition-colors hover:text-black"
              >
                Cancel
              </button>
            </div>
          ) : (
            <>
              <NavLink to="/home">
                <img
                  src="/icons/homeIcon.svg"
                  width={32}
                  height={32}
                  className="w-8 cursor-pointer"
                  alt="home"
                />
              </NavLink>

              <button onClick={() => setIsMobileSearchOpen(true)}>
                <img
                  src="/icons/searchIcon.svg"
                  width={32}
                  height={32}
                  className="w-8 cursor-pointer"
                  alt="search"
                />
              </button>
              <div className="relative flex h-11 w-11 items-center justify-center">
                {/* 1. Ikonka "Dodaj" (widoczna na Home/Saved) */}
                <NavLink
                  to="/create"
                  className={`absolute flex items-center justify-center transition-all duration-300 ease-out ${
                    isCreatePage
                      ? 'pointer-events-none scale-50 opacity-0'
                      : 'scale-100 opacity-100'
                  }`}
                >
                  <img
                    src="/icons/addIcon.svg"
                    width={32}
                    height={32}
                    className="w-8 cursor-pointer transition-transform active:scale-90"
                    alt="create"
                  />
                </NavLink>

                {/* 2. Przycisk "Zatwierdź/Ładowanie" (widoczny tylko w edytorze) */}
                <button
                  onClick={() =>
                    window.dispatchEvent(new Event('request-post-submit'))
                  }
                  disabled={isSubmittingPost}
                  className={`absolute flex h-11 w-11 items-center justify-center rounded-full bg-[#620a85] text-white shadow-lg transition-all duration-300 ease-out active:scale-90 disabled:opacity-50 ${
                    isCreatePage
                      ? 'scale-100 opacity-100'
                      : 'pointer-events-none scale-50 opacity-0'
                  }`}
                >
                  {isSubmittingPost ? (
                    // Spinner ładowania
                    <svg
                      className="h-5 w-5 animate-spin text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                        className="opacity-25"
                      />
                      <path
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        className="opacity-75"
                      />
                    </svg>
                  ) : (
                    // Ikonka zatwierdzenia
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={3}
                      stroke="currentColor"
                      className="h-7 w-7"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M4.5 12.75l6 6 9-13.5"
                      />
                    </svg>
                  )}
                </button>
              </div>

              <NavLink to="/saved">
                <img
                  src="/icons/heartOutline.svg"
                  className="w-8 cursor-pointer"
                  alt="saved"
                  width={32}
                  height={32}
                />
              </NavLink>

              <div className="relative" ref={mobileDropdownRef}>
                <img
                  src={currentUser?.photoURL || '/icons/defaultProfilePic.svg'}
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  className="h-8 w-8 cursor-pointer rounded-full shadow-sm"
                  alt="profile"
                  width={32}
                  height={32}
                />

                {isDropdownOpen && (
                  <div className="absolute bottom-12 right-[-10px] z-50 flex w-48 flex-col rounded-[16px] border border-gray-100 bg-white p-2 font-Outfit text-sm shadow-xl">
                    {currentUser ? (
                      <>
                        <button
                          onClick={() => handleMenuNavigation('/profile')}
                          className="cursor-pointer rounded-lg px-4 py-3 text-left font-medium hover:bg-gray-100"
                        >
                          Profile
                        </button>
                        <hr className="my-1 border-gray-200" />
                        <button
                          onClick={handleLogout}
                          className="cursor-pointer rounded-lg px-4 py-3 text-left font-bold text-red-500 hover:bg-red-50"
                        >
                          Sign Out
                        </button>
                      </>
                    ) : (
                      // --- ZMIANA: Widok dla gościa otwiera Modal na telefonie ---
                      <button
                        onClick={() => handleOpenAuthModal('login')}
                        className="cursor-pointer rounded-lg px-4 py-3 text-left font-bold text-[#620a85] hover:bg-gray-100"
                      >
                        Log in / Sign up
                      </button>
                    )}
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </header>

      {/* --- ZMIANA: Wstrzyknięty AuthModal --- */}
      <AuthModal
        isOpen={isAuthModalOpen}
        onClose={() => setIsAuthModalOpen(false)}
        initialMode={authModalMode}
      />
    </>
  );
}

export default Navbar;
